import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import EngagementPage from "./pages/EngagementPage";
import ImpactASPlusPortalPage from "./pages/ImpactASPlusPortalPage";
import ImpactASPlusPortalMainPage from "./pages/ImpactASPlusPortalMainPage";
import ImpactASPlusPage from "./pages/ImpactASPlusPage";
import EarlyCareerSelectionPage from "./pages/EarlyCareerSelectionPage";
import JobFitProductPage from "./pages/JobFitProductPage";
import InsightEdgeProductPage from "./pages/InsightEdgeProductPage";
import DiscAfricaProductPage from "./pages/DiscAfricaProductPage";
import DiscLensProductPage from "./pages/DiscLensProductPage";
import LeadershipMirrorProductPage from "./pages/LeadershipMirrorProductPage";
import CulturePulseProductPage from "./pages/CulturePulseProductPage";
import EiLensProductPage from "./pages/EiLensProductPage";
import PurposeMapProductPage from "./pages/PurposeMapProductPage";
import Impact360ProductPage from "./pages/Impact360ProductPage";
import ExecutiveMirrorProductPage from "./pages/ExecutiveMirrorProductPage";
import DiscLensTeamsProductPage from "./pages/DiscLensTeamsProductPage";
import TeamEdgeProductPage from "./pages/TeamEdgeProductPage";
import PortalEmbedPage from "./pages/PortalEmbedPage";
import DiagnosticsPage from "./pages/DiagnosticsPage";
import DiscAfricaPage from "./pages/DiscAfricaPage";
import LeadershipMirrorPage from "./pages/LeadershipMirrorPage";
import CulturePulsePage from "./pages/CulturePulsePage";
import PartnerAssessmentsPage from "./pages/PartnerAssessmentsPage";
import CoachingPage from "./pages/CoachingPage";
import AdvisoryPage from "./pages/AdvisoryPage";
import CapabilityBuildingPage from "./pages/CapabilityBuildingPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import ContactPage from "./pages/ContactPage";
import LeadershipSuccessionPage from "./pages/LeadershipSuccessionPage";
import OurPeoplePage from "./pages/OurPeoplePage";
import CorporateProfilePage from "./pages/CorporateProfilePage";
import NotFoundPage from "./pages/NotFoundPage";
import CookieConsent from "./components/CookieConsent";

// Client Resources (hidden pages)
import ElektronCulturePulseVideo from "./pages/client/ElektronCulturePulseVideo";
import UnionBankSheRisesVideo from "./pages/client/UnionBankSheRisesVideo";
import TrainingSnapshotVideo from "./pages/client/TrainingSnapshotVideo";
import CompanyFilmVideo from "./pages/client/CompanyFilmVideo";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/engagement" element={<EngagementPage />} />
          <Route path="/impact-as-plus" element={<ImpactASPlusPage />} />
          <Route path="/early-career-selection" element={<EarlyCareerSelectionPage />} />
          <Route path="/product/jobfit" element={<JobFitProductPage />} />
          <Route path="/product/insightedge" element={<InsightEdgeProductPage />} />
          <Route path="/product/disc-africa" element={<DiscAfricaProductPage />} />
          <Route path="/product/disc-lens" element={<DiscLensProductPage />} />
          <Route path="/product/leadership-mirror" element={<LeadershipMirrorProductPage />} />
          <Route path="/product/culture-pulse" element={<CulturePulseProductPage />} />
          <Route path="/product/ei-lens" element={<EiLensProductPage />} />
          <Route path="/product/purposemap" element={<PurposeMapProductPage />} />
          <Route path="/product/impact-360" element={<Impact360ProductPage />} />
          <Route path="/product/executive-mirror" element={<ExecutiveMirrorProductPage />} />
          <Route path="/product/disc-africa-teams" element={<DiscLensTeamsProductPage />} />
          <Route path="/product/team-edge" element={<TeamEdgeProductPage />} />
          <Route path="/product/linc" element={<PortalEmbedPage path="/product/linc" title="LINC" seoTitle="LINC | Impact AS Plus" description="LINC from Impact AS Plus, part of RESILIGENT's leadership intelligence system for Nigerian and African organisations." />} />
          <Route path="/briefing" element={<PortalEmbedPage path="/briefing" title="Book a briefing" seoTitle="Book a Briefing | Impact AS Plus" description="Book an Impact AS Plus briefing with RESILIGENT to see how leadership intelligence supports your people decisions." />} />
          <Route path="/sample-reports" element={<PortalEmbedPage path="/sample-reports" title="Sample reports" seoTitle="Sample Reports | Impact AS Plus" description="View Impact AS Plus sample reports from RESILIGENT's leadership assessment, 360, culture and hiring instruments." />} />
          <Route path="/diagnostics" element={<DiagnosticsPage />} />
          <Route path="/disc-africa" element={<DiscAfricaPage />} />
          <Route path="/leadership-mirror" element={<LeadershipMirrorPage />} />
          <Route path="/culturepulse" element={<CulturePulsePage />} />
          <Route path="/partner-assessments" element={<PartnerAssessmentsPage />} />
          <Route path="/coaching" element={<CoachingPage />} />
          <Route path="/advisory" element={<AdvisoryPage />} />
          <Route path="/capability-building" element={<CapabilityBuildingPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/impact-as-plus-portal" element={<ImpactASPlusPortalPage />} />
          <Route path="/impact-as-plus-portal-main" element={<ImpactASPlusPortalMainPage />} />
            <Route path="/contact" element={<ContactPage />} />
          <Route path="/leadership-succession-intelligence" element={<LeadershipSuccessionPage />} />
          <Route path="/our-people" element={<OurPeoplePage />} />
          <Route path="/corporate-profile" element={<CorporateProfilePage />} />
          
          {/* Hidden Client Resources */}
          <Route path="/client/elektron/culturepulse-intro" element={<ElektronCulturePulseVideo />} />
          <Route path="/client/unionbank/sherises-coaching" element={<UnionBankSheRisesVideo />} />
          <Route path="/client/resiligent/training-snapshot" element={<TrainingSnapshotVideo />} />
          <Route path="/client/resiligent/company-film" element={<CompanyFilmVideo />} />
          
          <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
